/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import AdminEditEvidenceRequestPage from "./admin";
import UserEditEvidenceRequest from "./user";
import { getUserInfo } from "../../helpers/user";

const EditEvidenceRequestPageRouteWrapper = () => {
  const userInfo = getUserInfo();

  if (userInfo.role === "admin" || userInfo.role === "auditor") {
    return <AdminEditEvidenceRequestPage />;
  } else if (userInfo.role === "user" || userInfo.role === "org_admin") {
    return <UserEditEvidenceRequest />;
  } else {
    return <Navigate to="/login" />;
  }
};

export default EditEvidenceRequestPageRouteWrapper;
